
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {Injectable} from '@angular/core';
import {PartnerPersonModel} from '../../../api/entity/partnerPerson.model';
import {PartnerPersonConverter} from '../../../api/converter/partnerPerson.converter';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable({
    providedIn: 'root'
})
export class PartnerPersonService extends AbstractDataServiceV2<PartnerPersonModel, PartnerPersonConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PartnerPersonConverter) {
        super('PartnerPerson', http, httpUrlGenerator, logger, config, converter);
    }
}
